// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/hero_content_alt/hero_content_alt.js';
import '../../flex/content/layouts/hero_content_overlay/hero_content_overlay.js';
